import React, { useEffect, useState } from "react";
import backicon from '../../../../../Assets/icons/backIcon.svg';
import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../services/api/API";
import { Placeholder } from "react-bootstrap";


const AddJobCardIssue = () => {
    const [formData, setFormData] = useState({ issue_status: 0 });
    const authToken = localStorage.getItem("authToken");
    const businessPartnerId =localStorage.getItem("business_partner_id")
    const location = useLocation();
    const { jobCarddata,jobCarddataId } = location?.state || {};
    const [activeSection, setActiveSection] = useState('Customer');
    const [businessPartnertypedd, setBusinessPartnerTypedd] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [validationErrors, setValidationErrors] = useState({});
    const [complainList, setComplainList] = useState([]);
    const [technicianList, setTechnicianList] = useState([]);
    const [repair, setRepair] = useState([])

    const navigate = useNavigate();

    const IssueInputs = [
        {
            name: "Complain",
            label: "Complain",
            type: "dropdown",
            required: true,
            // options: options,
            options: complainList,
            gridClass: "col-lg-4",
            validation: { required: true,
              
             },
        },
        {
            name: "Complain_Description",
            label: "Complain Description",
            type: "text",
            placeholder:'Enter Complain Description',
            required: true,
            gridClass: "col-lg-4",
            validation: { required: true,
                pattern: /^[A-Za-z0-9 ]*$/,
                message: "Only alphabets and digits are allowed",
             },
        },

        {
            name: "estimated_cost",
            label: "Estimate Cost",
            type: "number",
            placeholder:'Enter Estimate Cost',
            required: true,
            gridClass: "col-lg-4",
            validation: { 
                required: true ,
                pattern: /^\d+(\.\d{1,2})?$/, // Updated pattern to allow up to 2 decimal places
                message: "Only digits or up to two decimal places are allowed*",
            },
        },
        // {
        //     name: "technician",
        //     label: "Technician",
        //     type: "dropdown",
        //     required: true,
        //     // options: options,
        //     options: technicianList || [],
        //     gridClass: "col-lg-4",
        //     validation: { required: true },
        //     disabled: true
        // },
        // {
        //     name: "remark",
        //     label: "Remark",
        //     placeholder:'Enter Remark',
        //     type: "text",
        //     required: true,
        //     gridClass: "col-lg-4",
        //     validation: { required: true,maxLength:50,
        //         pattern: /^[A-Za-z0-9 ]*$/,
        //         message: "Only alphabets and digits are allowed",
        //      },
        //      disabled: true
         
        // },
        // {
        //     name: "issue_status",
        //     label: "Issue Status",
        //     type: "dropdown",
        //     options: [
        //         { label: "Pending", value: 0 },
        //         { label: "Done", value: 1 },
        //     ],
        //     required: true,
        //     gridClass: "col-lg-4",
        //     validation: { required: true },
        // },
        // {
        //     name: "repair",
        //     label: "Repair",
        //     type: "dropdown",
        //     options: repair || [],
        //     required: true,
        //     gridClass: "col-lg-4",
        //     validation: { required: true },
        //     dropdownOptionsListPosition:'top',
        //     disabled: true
        // },
        // {
        //     name: "east_time",
        //     label: "Estimate Time",
        //     type: "text",
        //     required: true,
        //     gridClass: "col-lg-4",
        //     validation: { required: true },
        //     disabled: true
        // },
    ];

    
    const fetchComplainList = async (page = 0, pageSize = 1) => {
        try {
            const response = await axiosInstance.post('/jobcard/getcustomerdetails', {
                business_partner_id: businessPartnerId==0?1:businessPartnerId,
                FilterId: null,
                FilterString: null,
                Type: "Complain"

            }, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                }
            });
            const formattedData = response.data.data.map((item, index) => ({
                label: item?.name,
                value: item?.id
                // status: item?.solved === 0 ? 'Pending' : 'Done',
                // job_card_no: onClickNavigetion(item)

            }));
            setComplainList(formattedData)
        } catch (error) {
            console.error('Error fetching business partners:', error);
        }
    };

    const fetchTecnicianList = async (page = 0, pageSize = 1) => {
        try {
            const response = await axiosInstance.post('/jobcard/getcustomerdetails', {
                business_partner_id: businessPartnerId==0?1:businessPartnerId,
                FilterId: null,
                FilterString: null,
                Type: "Technician"
            }, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                }
            });
            const formattedData = response.data.data.map((item, index) => ({
                label: item?.name,
                value: item?.id
                // status: item?.solved === 0 ? 'Pending' : 'Done',
                // job_card_no: onClickNavigetion(item)

            }));
            setTechnicianList(formattedData)
        } catch (error) {
            console.error('Error fetching business partners:', error);
        }
    };

    const fetchRepairList = async (page = 0, pageSize = 1) => {
        try {
            const response = await axiosInstance.post('/jobcard/getcustomerdetails', {
                business_partner_id: businessPartnerId==0?1:businessPartnerId,
                FilterId: null,
                FilterString: null,
                Type: "Repair"
            }, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                }
            });
            const formattedData = response.data.data.map((item, index) => ({
                label: item?.name,
                value: item?.id
                // status: item?.solved === 0 ? 'Pending' : 'Done',
                // job_card_no: onClickNavigetion(item)

            }));
            setRepair(formattedData)
        } catch (error) {
            console.error('Error fetching business partners:', error);
        }
    };

    const handleFormSubmit = async (data) => {
        if (jobCarddata?.comp_id) {
            try {
                const response = await axiosInstance.post('/jobcardcomplain/jobcardcomplainupdate', {
                    business_partner_id:businessPartnerId==0?1:businessPartnerId ,
                    job_card_id: jobCarddata?.job_card_id || null,
                    comp_id:jobCarddata?.comp_id,
                    complain_id: data?.Complain || null,
                    complain_desc: data?.Complain_Description || null,
                    estcost: data?.estimated_cost || null,
                    technician_id: data?.technician || null,
                    remark: data?.remark || null,
                    issue_status: data?.issue_status,
                    esttime: data?.east_time || null,
                    tech_remark: null,
                    actual_time:null,
                    repair_id: data?.repair || null,
                    status: 1
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    }
                });
                if (response?.status) {
                    const AddIssueData = response?.data?.data?.jobcardcomplainDetails;
                    navigate('/manage-services/job-card/job-card-details',{state:{ data: JSON.parse(JSON.stringify(AddIssueData)) }})
                }
            } catch (error) {
                console.error('Error fetching business partners:', error);
            }
        }
        else {
            try {
                const response = await axiosInstance.post('/jobcardcomplain/create', {
                    business_partner_id:businessPartnerId==0?1:businessPartnerId ,
                    job_card_id: jobCarddataId || null,
                    complain_id: data?.Complain || null,
                    complain_desc: data?.Complain_Description || null,
                    estcost: data?.estimated_cost || null,
                    technician_id: data?.technician || null,
                    remark: data?.remark || null,
                    issue_status: 0,
                    esttime: data?.east_time || null,
                    actual_time:null,
                    tech_remark: null,
                    repair_id: data?.repair || null,
                    status: 1
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    }
                });
               
                if (response?.status) {
                    const AddIssueData = response?.data?.data?.responseData;
                    navigate('/manage-services/job-card/job-card-details',{state:{ data: JSON.parse(JSON.stringify(AddIssueData)) } })
                }

            } catch (error) {
                console.error('Error fetching business partners:', error);
            }
        }
    }

    useEffect(() => {
        fetchComplainList();
        fetchTecnicianList();
        fetchRepairList();
    }, []);


    useEffect(() => {
        if (jobCarddata?.comp_id) {
            setFormData(
                {
                    Complain: jobCarddata?.complain_id,
                    Complain_Description: jobCarddata?.complain_desc,
                    estimated_cost: jobCarddata?.estcost,
                    remark: jobCarddata?.remark,
                    issue_status: jobCarddata?.issue_status,
                    east_time: jobCarddata?.esttime,
                    repair: jobCarddata?.repair_id,
                    technician: jobCarddata?.technician_id
                }
            )
        }
    },[jobCarddata])

    const backNavigate = () => {
        navigate("/manage-services/job-card")
    }

    return (
        <div>
            <ToastContainer />
            <div className="backbutton mt-2 mb-2">
                <img onClick={backNavigate} src={backicon} alt="back" />
                <span className="backbtntitle">{jobCarddata?.comp_id ? "Update Issue" : 'Add Issue'}</span>
            </div>
            <div className="form-container ">
                <div className="cust-det-title mt-2 mb-2">
                    Issue Details
                </div>
                <DynamicForm
                    formConfig={IssueInputs}
                    formData={formData}
                    setFormData={setFormData}
                    onSubmit={handleFormSubmit}
                    validationErrors={validationErrors}
                    setValidationErrors={setValidationErrors}
                />

            </div>


            <div className="btncontainer mt-3">
                <button
                    onClick={() => { handleFormSubmit(formData) }}
                    className="submit-btn">
                    {isLoading ? "Submitting..." : "Submit"}
                </button>
            </div>
        </div>
    );
};

export default AddJobCardIssue;
